// eslint-disable-next-line no-unused-vars
import { React, useEffect, useState } from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import CardLayout from "../../components/ReusableComponents/CardLayout";
import UsersTracker from "../../components/ReusableComponents/UsersTracker";
import { ProductHeadCells, ProductTabList, OrderHistoryCells, CustomerCells, CartCells } from "./ProductData";
import SingleOrder from "./Sections/SingleOrder";
import ProductsDataTable from "./ProductsDataTable";
import ProductCategories from "./Sections/ProductCategories";
import AddProducts from "./Sections/AddProducts";
import SingleProduct from "./Sections/SingleProduct";
import { CardWrapper } from "../dashboard/dashboard.styled";
import { orderChartsData } from "../dashboard/DummyData";
import Parse from "../../api/ApiConfig";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../redux/AppSlice";
import { getFilteredTableData } from "../../utils/Utils";

function ProductPage() {
	let navigate = useNavigate();
	const dispatch = useDispatch();
	let { category, productId } = useParams();
	const [tableData, setTableData] = useState([]);
	const [defaultData, setDefaultData] = useState(); //this is for the search functionality
	const [currentTab, setCurrentTab] = useState(category || "productList");
	const [TableHeadCells, setTableHeadCells] = useState(ProductHeadCells);
	const [dateFilter, setDateFilter] = useState("6 Months");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		let unsubscribed = false;
		// console.log(category); //switch sttement
		if (category === "productList" && !unsubscribed) {
			ProductList();
		} else if (category === "orderHistory" && !unsubscribed) {
			orderHistoryList();
		} else if (category === "customers" && !unsubscribed) {
			getCustomers();
		} else if (category === "cart" && !unsubscribed) {
			getCart();
		} else {
			ProductList();
		}

		return () => {
			unsubscribed = true;
		};
	}, [category]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [tableData]);

	async function ProductList() {
		dispatch(setLoadingState(true));
		try {
			const products = Parse.Object.extend("Products");
			const query = new Parse.Query(products);
			const results = await query.find();
			const mappedData = results
				.map((item) => ({
					id: item.id, // Include the id property
					...item.attributes, // Spread the remaining attributes
				}))
				?.sort(
					(dataOne, dataTwo) =>
						new Date(dataTwo?.createdAt).getTime() - new Date(dataOne?.createdAt).getTime()
				);
			// console.log(mappedData)
			dispatch(setLoadingState(false));
			setTableData(mappedData);
			setDefaultData(mappedData);
			setTableHeadCells(ProductHeadCells);
		} catch (error) {
			console.log(error);
			toast.error("Error fetching data");
			dispatch(setLoadingState(false));
			setTableData([]);
		}
	}

	//fetch list of orders
	const orderHistoryList = async () => {
		dispatch(setLoadingState(true));
		try {
			const Orders = Parse.Object.extend("Orders");
			const query = new Parse.Query(Orders);
			const orders = await query.find();
			const data = orders.map((item) => {
				return { id: item.id, ...item.attributes };
			});
			dispatch(setLoadingState(false));
			setTableData(data);
			setDefaultData(data);
			setTableHeadCells(OrderHistoryCells);
		} catch (error) {
			toast.error("Error fetching data");
			dispatch(setLoadingState(false));
			setTableData([]);
		}
	};

	const getCustomers = async () => {
		dispatch(setLoadingState(true));
		try {
			const response = await fetch(`${Parse.serverURL}/functions/getCustomers`, {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			});

			const res = await response.json();
			if (res.error) {
				dispatch(setLoadingState(false));
				toast.error(res.error);
			} else {
				let data = res.result.map((item) => {
					return { lastPurchase: item.lastPurchase, ...item.user };
				});
				setTableHeadCells(CustomerCells);
				setTableData(data);
				setDefaultData(data);
				dispatch(setLoadingState(false));
			}
		} catch (error) {
			toast.error("Error fetching data");
			dispatch(setLoadingState(false));
			setTableData([]);
		}
	};

	const getCart = async () => {
		dispatch(setLoadingState(true));
		try {
			const response = await fetch(`${Parse.serverURL}/functions/getCart`, {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			});

			const res = await response.json();
			if (res.error) {
				dispatch(setLoadingState(false));
				toast.error(res.error);
			} else {
				let data = res.result.map((item) => {
					return {
						total: item.price,
						name: `${item.userId.firstName} ${item.userId.lastName}`,
						...item.productId,
					};
				});

				setTableHeadCells(CartCells);
				setTableData(data);
				setDefaultData(data);
				dispatch(setLoadingState(false));
			}
		} catch (error) {
			toast.error("Error fetching data!");
			dispatch(setLoadingState(false));
			setTableData([]);
		}
	};

	const handleTabChange = (id) => {
		setCurrentTab(id);
		navigate(`/products/${id}`);
	};

	const handleDateFilterChange = (e) => {
		// Filter tableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, tableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
		// console.log(filteredTableData)
	};

	return (
		<AdminDashboardLayout data={tableData} defaultData={defaultData} setData={setTableData}>
			<DashboardWrapper>
				{/* Conditionally render charts */}
				{category === "orderHistory" ? (
					<CardWrapper>
						{orderChartsData.map((data) => {
							return (
								<CardLayout key={data.id} type={data.type}>
									<UsersTracker
										key={data.id}
										type={data.type}
										year={data.year}
										number={data.number}
										rate={data.rate}
										progressType={data.progressType}
									/>
								</CardLayout>
							);
						})}
					</CardWrapper>
				) : null}
				<FilterCategory
					currentTab={currentTab}
					tabList={ProductTabList}
					handleClick={(title) => handleTabChange(title)}
				/>

				{/* conditionally render components */}
				{/* //switch statement */}
				{/* better structure of the url */}
				<>
					{category === "addProducts" ? (
						<AddProducts />
					) : category === "categories" ? (
						<ProductCategories />
					) : productId && category !== "orders" ? (
						<SingleProduct />
					) : category === "orders" && productId ? (
						<SingleOrder />
					) : (
						<ProductsDataTable
							tableData={filteredData}
							headCells={TableHeadCells}
							type={category}
							ProductList={ProductList}
							orderHistoryList={orderHistoryList}
							category={category}
							dateFilter={dateFilter}
							handleDateFilterChange={handleDateFilterChange}
						/>
					)}
				</>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default ProductPage;
